export const dashboardTour = [
  {
    id: "welcome",
    target: '[data-tour="dashboard-welcome"]',
    title: "Welcome to KWICPE Dashboard",
    content: "Welcome to the Merchant Dashboard...",
    disableBeacon: true,
    placement: "center",
    route: "/dashboard",
    buttons: ["skip", "primary"],
    allowedRoles: ["admin", "subAdmin", "mops"],
  },

  {
    id: "wallet-balance",
    target: '[data-tour="wallet-balance"]',
    title: "Wallet Overview",
    content:
      "This section displays your current Wallet Balance and Ledger Balance available in your account.",
    placement: "bottom",
    route: "/dashboard",
    isFixed: true,
    allowedRoles: ["admin", "subAdmin", "mops"],
  },

  {
    id: "date-filter",
    target: '[data-tour="date-filter"]',
    title: "Transaction Date Filter",
    content:
      "Use this filter to view transaction reports and dashboard analytics for a selected date range.",
    placement: "top",
    route: "/dashboard",
    allowedRoles: ["admin", "subAdmin", "mops"],
  },

  {
    id: "stats-cards",
    target: '[data-tour="stats-cards"]',
    title: "Transaction Summary",
    content:
      "These dashboard cards provide a quick overview of your Payin, Payout, Deposits, Withdrawals, and Commission statistics.",
    placement: "bottom",
    route: "/dashboard",
    allowedRoles: ["admin", "subAdmin", "mops"],
  },
  {
    id: "account-menu",
    target: '[data-tour="sidebar-account"]',
    title: "Account Settings",
    content: "Click here to open account settings.",
    route: "/dashboard",
    allowedRoles: ["admin"],
  },

  {
    id: "webhook-urls",
    target: '[data-tour="webhook-urls"]',
    title: "Configure Webhook URLs",
    content:
      "Update your Webhook URLs. Webhook URLs allow KWICPE to send real-time transaction status updates and payment notifications directly to your system.",
    placement: "left",
    route: "/account/details",
    disableBeacon: true,
    allowedRoles: ["admin"],
  },

  {
    id: "server-ip-tab",
    target: '[data-tour="server-ip-tab"]',
    title: "Whitelist Server IP",
    content:
      "Register your IP address in the Whitelist Server IP list.",
    placement: "right",
    route: "/account/details",
    allowedRoles: ["admin"],
  },
  {
    id: "server-ip",
    target: '[data-tour="server-ip"]',
    title: "Whitelist Server IP",
    content:
      "Add your server IP address to enable secure communication with KWICPE.",
    placement: "left",
    route: "/account/ips-merchant",
    allowedRoles: ["admin"],
  },

  {
    id: "complete",
    target: "body",
    title: "🎉Setup Complete",
    content:
      "Your account setup is now complete. Once your Webhook URLs and IP addresses are configured, your integration with KWICPE is ready for secure transaction processing and real-time notifications.",
    placement: "center",
    route: "/dashboard",
    allowedRoles: ["admin", "subAdmin", "mops"],
  },
];